<div>
    <div id="map" class="m-3" style="height: 50%; min-height: 500px; margin: 20px; border: 2px solid #4caf50; border-radius: 8px; padding: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); z-index: 800;">
    </div>    
</div>
